import React from 'react';

export const RequestVerification = () => (
  <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_10785_8021)">
      <path
        d="M2 8.22222C2 9.03934 2.16094 9.84845 2.47364 10.6034C2.78633 11.3583 3.24466 12.0442 3.82245 12.622C4.40023 13.1998 5.08617 13.6581 5.84108 13.9708C6.596 14.2835 7.40511 14.4444 8.22222 14.4444C9.03934 14.4444 9.84845 14.2835 10.6034 13.9708C11.3583 13.6581 12.0442 13.1998 12.622 12.622C13.1998 12.0442 13.6581 11.3583 13.9708 10.6034C14.2835 9.84845 14.4444 9.03934 14.4444 8.22222C14.4444 7.40511 14.2835 6.596 13.9708 5.84108C13.6581 5.08617 13.1998 4.40023 12.622 3.82245C12.0442 3.24466 11.3583 2.78633 10.6034 2.47364C9.84845 2.16094 9.03934 2 8.22222 2C7.40511 2 6.596 2.16094 5.84108 2.47364C5.08617 2.78633 4.40023 3.24466 3.82245 3.82245C3.24466 4.40023 2.78633 5.08617 2.47364 5.84108C2.16094 6.596 2 7.40511 2 8.22222Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M18 18.0003L12.6666 12.667" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M5.55554 8.22211L7.33332 9.99989L10.8889 6.44434"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_10785_8021">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default RequestVerification;
